<template>
  <view-section title="Contributors" :padding-y="false" panel-loading>
    <div
      class="tw-flex tw-items-center tw-justify-between tw-py-2.5 tw-border-b tw-border-theme-2 last:tw-border-b-0 tw-space-x-2"
    >
      <div class="tw-flex tw-items-center tw-space-x-2">
        <div class="tw-size-8 tw-rounded-full game-tile-background-color"></div>
        <loading-label />
      </div>

      <div class="tw-flex tw-space-x-3">
        <div class="tw-size-4 tw-rounded game-tile-background-color"></div>
        <div class="tw-size-4 tw-rounded game-tile-background-color"></div>
      </div>
    </div>
  </view-section>
</template>
<script>
import LoadingLabel from '@components/Loading/LoadingLabel.vue'
import ViewSection from '@components/View/ViewSection.vue'
export default {
  components: {
    LoadingLabel,
    ViewSection,
  },
}
</script>
